import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SHOT_TYPES } from "@/lib/zones";

export default function ShotDialog({ open, onOpenChange, zone, onConfirm }) {
  const [shotType, setShotType] = useState("media_distancia");
  const [made, setMade] = useState("");
  const [missed, setMissed] = useState("");

  useEffect(() => {
    if (!zone) return;
    if (zone.id === "garrafao") setShotType("bandeja");
    else if (zone.points === 3) setShotType("tres_pontos");
    else setShotType("media_distancia");
    setMade("");
    setMissed("");
  }, [zone, open]);

  if (!zone) return null;

  const madeN = parseInt(made) || 0;
  const missedN = parseInt(missed) || 0;
  const total = madeN + missedN;
  const pct = total > 0 ? Math.round((100 * madeN) / total) : 0;

  const handleSave = () => {
    if (total === 0) return;
    onConfirm({ zone_id: zone.id, shot_type: shotType, made_count: madeN, missed_count: missedN });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#141414] border-zinc-800 text-white" data-testid="shot-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl uppercase tracking-tight">
            {zone.name} <span className="text-[#FF3B30]">• {zone.points} PTS</span>
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-5 py-2">
          <div>
            <label className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400">
              Tipo de arremesso
            </label>
            <Select value={shotType} onValueChange={setShotType}>
              <SelectTrigger className="mt-2 bg-[#0A0A0A] border-zinc-800 text-white" data-testid="shot-type-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-[#141414] border-zinc-800 text-white">
                {SHOT_TYPES.map((t) => (
                  <SelectItem key={t.id} value={t.id} data-testid={`shot-type-${t.id}`}>
                    {t.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs font-bold uppercase tracking-[0.2em] text-[#22C55E]">
                Acertos
              </label>
              <Input
                data-testid="shot-made-input"
                type="number"
                min="0"
                inputMode="numeric"
                placeholder="0"
                value={made}
                onChange={(e) => setMade(e.target.value.replace(/[^0-9]/g, ""))}
                className="mt-2 bg-[#0A0A0A] border-[#22C55E]/40 text-white text-3xl font-display font-black text-center h-16"
              />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-[0.2em] text-[#EF4444]">
                Erros
              </label>
              <Input
                data-testid="shot-missed-input"
                type="number"
                min="0"
                inputMode="numeric"
                placeholder="0"
                value={missed}
                onChange={(e) => setMissed(e.target.value.replace(/[^0-9]/g, ""))}
                className="mt-2 bg-[#0A0A0A] border-[#EF4444]/40 text-white text-3xl font-display font-black text-center h-16"
              />
            </div>
          </div>

          {total > 0 && (
            <div className="flex items-center justify-between px-4 py-3 bg-[#0A0A0A] border border-zinc-800 rounded-sm" data-testid="shot-preview">
              <div className="text-xs uppercase tracking-widest text-zinc-500 font-bold">
                {total} arremesso{total > 1 ? "s" : ""}
              </div>
              <div className="font-display font-black text-2xl tracking-tighter">
                {pct}%
              </div>
            </div>
          )}
        </div>

        <DialogFooter className="grid grid-cols-2 gap-3">
          <Button
            onClick={() => onOpenChange(false)}
            data-testid="shot-cancel-btn"
            className="bg-transparent border border-zinc-700 hover:border-zinc-500 hover:bg-zinc-800 text-white font-bold uppercase tracking-wide py-6 rounded-sm"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSave}
            disabled={total === 0}
            data-testid="shot-save-btn"
            className="bg-[#FF3B30] hover:bg-red-600 text-white font-bold uppercase tracking-wide py-6 rounded-sm disabled:opacity-40"
          >
            Salvar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
